__turbopack_context__.v({
  "ctaButton": "CareerServiceBanner-module-scss-module__azKxQq__ctaButton",
  "heroContainer": "CareerServiceBanner-module-scss-module__azKxQq__heroContainer",
  "heroContent": "CareerServiceBanner-module-scss-module__azKxQq__heroContent",
  "heroContentWrapper": "CareerServiceBanner-module-scss-module__azKxQq__heroContentWrapper",
  "heroDescription": "CareerServiceBanner-module-scss-module__azKxQq__heroDescription",
  "heroHeading": "CareerServiceBanner-module-scss-module__azKxQq__heroHeading",
  "hidden": "CareerServiceBanner-module-scss-module__azKxQq__hidden",
  "highlightYellow": "CareerServiceBanner-module-scss-module__azKxQq__highlightYellow",
  "statCard": "CareerServiceBanner-module-scss-module__azKxQq__statCard",
  "statCardDivider": "CareerServiceBanner-module-scss-module__azKxQq__statCardDivider",
  "statDescription": "CareerServiceBanner-module-scss-module__azKxQq__statDescription",
  "statIcon": "CareerServiceBanner-module-scss-module__azKxQq__statIcon",
  "statTitle": "CareerServiceBanner-module-scss-module__azKxQq__statTitle",
  "statsContainerDweb": "CareerServiceBanner-module-scss-module__azKxQq__statsContainerDweb",
  "statsContainerMobile": "CareerServiceBanner-module-scss-module__azKxQq__statsContainerMobile",
  "statsGrid": "CareerServiceBanner-module-scss-module__azKxQq__statsGrid",
});
